module.exports = __webpack_public_path__ + "static/media/google.86843ef1.png";